const hamburger = document.querySelector('#hamburger');
const mainNavigation = document.querySelector('#main-navigation');
const vinegarShow = document.getElementById('vinegarShow');
// const languageTrigger = document.getElementById('language-selector-trigger');

hamburger?.addEventListener('click', () => {
  const expanded = hamburger.getAttribute('aria-expanded') === 'true';
  if (expanded) {
    hamburger.setAttribute('aria-expanded', 'false');
  } else {
    hamburger.setAttribute('aria-expanded', 'true');
    // languageTrigger?.setAttribute('aria-expanded', 'false');
    mainNavigation.querySelector('[role=menuitem]').focus();
  }
});

vinegarShow?.addEventListener('click', () => {
  vinegar.show();
  return false;
});

const firstContactperson = document.querySelector('.contactperson.streamfield.streamfield-cta');
if (firstContactperson) {
  document.querySelectorAll('.js-contactperson-anchor').forEach(link => {
    link.removeAttribute('hidden');
    link.addEventListener('click', e => {
      e.preventDefault();
      firstContactperson.scrollIntoView({ behavior: 'smooth' });
    });
  });
}
